<template>
 <div class="w-100 d-flex flex-column align-items-center">
	<hr>
    <h3 class="w-100 text-center">Aplicar tarifa especial</h3>
	<div class="w-md-75 w-lg-100">
		<b-row>
			<div class="col-md-12 col-lg-6">
				<card-service
				:showButtons="false"
				:currency="formModel.currency"
				:ticket="ticket"
				:shuttle="shuttle"
				/>
			</div>
			<div class="col-md-12 col-lg-6">
				<b-form  >
					<b-row>
						<div class="col-12">
							<b-form-group
							id="input-group-1"
							label-for="input-1"
							>
								<label class="mr-sm-2">Nuevo Total</label>
								<b-row>
									<div class="col-md-12 col-lg-8">
										<b-input-group size="lg" prepend="$" :append="currency">
											<b-form-input v-model="formNewPrice.amount" type="number"></b-form-input>
										</b-input-group>
									</div>
								</b-row>
							</b-form-group>
						</div>
						<div class="col-12">
							<b-form-group id="input-group-2" label="Motivo" label-for="input-2">
								<b-form-textarea v-model="formNewPrice.reason"></b-form-textarea>
							</b-form-group>
							<div class="w-100 d-flex justify-content-end">
								<b-button  variant="success" @click="bookAction">ADD TO CART</b-button>
							</div>
						</div>


					</b-row>

					<b-row>


					</b-row>



				</b-form>
			</div>
		</b-row>
	</div>



    <b-overlay :show="showConfirmation" no-wrap>
        <template #overlay>
            <div ref="dialog" tabindex="-1" role="dialog" class="text-center p-1">
                <p>
                    <strong id="form-confirm-label">¿Esta seguro que desea aplicar el precio especial?</strong><br>

                </p>
                 <p>Precio original: {{originalPriceFormatted}} </p>
                 <p>Precio especial: {{newPriceFormatted}} </p>
                 <h4 class="text-success"><b>{{difference}}</b></h4>
                <div class="text-center">
                    <b-button variant="outline-danger" class="mr-3" @click="()=>{showConfirmation=false}">
                        Cancelar
                    </b-button>
                    <b-button variant="outline-success" @click="setNewPrice">Confirmar</b-button>
                </div>
            </div>
        </template>
    </b-overlay>
 </div>
</template>

<script>
import CardService from "./CardService";
export default {
    components: {
      CardService
    },
    props: {
      shuttle: { type: Object, required: true } ,
      ticket:{type: String,required:true},
      formModel:{type: Object, required: true}
    },
    data() {
      return {
        showConfirmation:false,
        formNewPrice:{
            amount:0,
            reason:""
        }
      };
    },
    computed: {
        originalPriceFormatted(){
            return "$"+this.shuttle[this.ticket]+" "+ this.currency;
        },
        newPriceFormatted(){
            return "$"+this.formNewPrice.amount+" "+ this.currency;
        },
        currency(){
            return this.formModel.currency.toUpperCase();
        },

        difference(){
            let res = parseFloat(this.formNewPrice.amount-this.shuttle[this.ticket])
            res = res.toFixed(2)
            let mensaje = "";
            if(res>=0){
                mensaje = "Total AGREGADO: $"+res+" "+this.currency
            }else{
                mensaje = "Total DESCUENTO: $"+Math.abs(res)+" "+this.currency
            }
            return mensaje
        }
    },
    methods: {
        setNewPrice(){
            let newRate = {...this.shuttle};
            newRate[this.ticket+"Original"] = newRate[this.ticket];//precio original
            newRate[this.ticket] = this.formNewPrice.amount;

            this.$emit('rateSelectedOffer',{
                originalRate:{...this.shuttle},
                customRate:newRate,
                formData:{...this.formNewPrice}
            });

        },
        bookAction(){
            try{
                if(this.isEmpty(this.formNewPrice.amount) || this.formNewPrice.amount<=0 ){
                    throw new Error("Monto es requerido")
                }
                if(this.isEmpty(this.formNewPrice.reason)){
                    throw new Error("Motivo es requerido")
                }
                this.showConfirmation = true;
            }catch(err){
                this.$root.showAlert(err.message,{variant:'danger'})
            }

        },
        isEmpty(val){
			return (val ===null || val === undefined || val==="");
		}

    },
    mounted(){
        this.formNewPrice.amount = this.shuttle[this.ticket]
    }
  };
</script>

